import { Grid, Typography } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react'

import { NavigateFunction, useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import NavigateListCustom from '../../../components/navigation/NavigationListCustom';
import { routeName } from '../../../routes/routeName';
import { ButtonOutlined, ButtonPrimary } from '../../../components/button/ButtonCustoms';
import InputTextField from '../../../components/input/inputTextField';
import InputDatePicker from '../../../components/input/inputDatePicker';
import { ExaminationCalendarApi } from '../../../api/examination-calendar/examination-calendar.api';
import { swalError, swalSuccess } from '../../../components/alert/swal';
import moment from 'moment';
import { timeToView } from '../../../utils/date.utils';
import { ExaminationCalendarStudentViewApi } from '../../../api/examination-calendar-student-view/examination-calendar-student-view.api';
import AutocompleteSelect from '../../../components/select/autoCompleteSelect';
import { useSelector } from 'react-redux';
import { MENU_TYPE } from './enum';
const defaultState = {
    id_examination_calendar: 0,
    id_student: 0,
    examination_calendar_date: undefined
}
export default function StudentsAddExaminationCalendar() {
    const { t } = useTranslation();
    const location = useLocation()
    const pathname = location.pathname
    const navigate: NavigateFunction = useNavigate();
    const search_params = new URLSearchParams(location.search);
    const mode = search_params.get("mode");
    const { profile } = useSelector((state: any) => state.profile);
    const [searchParams] = useSearchParams();

    const [examinationCalendar, setExaminationCalendar] = useState<any[]>([]);
    const [search, setSearch] = useState<any>('')

    const [form, setForm] = useState<any>(defaultState)
    const getExaminationCalendar = useCallback(async () => {
        try {
            let condition: any = {
                page: 1,
                limit: 100
            };

            if (search) condition = { ...condition, search: search };
            const res = await ExaminationCalendarApi.list(condition);
            const data = res.data
            if (data?.status < 300) {
                setExaminationCalendar(data?.data.items);
            } else {
            }
        } catch (error) {
        }
    }, [search]);

    useEffect(() => {
        getExaminationCalendar();
    }, [getExaminationCalendar]);

    const handleSubmit = async () => {
        const body = {
            id_examination_calendar: form?.id_examination_calendar,
            id_student: profile?.id_student,
            examination_calendar_date: form?.examination_calendar_date
        }
        await ExaminationCalendarStudentViewApi.post(body).then((res: any) => {
            if (res.status < 300) {
                swalSuccess(t('เพิ่มปฏิทินตารางการสอบ เรียบร้อยแล้ว'))
                navigate(routeName.students.ScheduleCalenda);
                // handleClose()
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
        })
    }
    useEffect(() => {
        if (location.state) {
            setForm({ ...form, id_examination_calendar: location.state?.id_examination_calendar, examination_calendar: location.state })
        }

    }, [])

    return (
        <div className="h-auto">
            <NavigateListCustom
                navigateData={[
                    {
                        name: t("ปฏิทินตารางการสอบ"),
                        key: "1",
                        pathName: routeName.students.ScheduleCalenda,
                        searchParams: {
                            type_select: MENU_TYPE.EXAM_BOOKING
                        }
                    },
                    {
                        name: t("ส่งเรื่องขอจองวันสอบ"),
                        key: "2",
                        pathName: pathname
                    },

                ]}
            />

            {/* header */}
            <section className="my-4">
                <Typography variant="h3">ส่งเรื่องขอจองวันสอบ</Typography>
            </section>

            <section className="my-4">
                <Grid container spacing={2}>
                    <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        sx={{
                            alignSelf: "end",
                        }}
                    >
                        <AutocompleteSelect
                            required
                            heading={t('เริ่อง')} placeholder={t('เริ่อง')}
                            // freeSolo
                            labelId={'S'} options={examinationCalendar?.filter((item: any) => item.examination_calendar_status === 'OPEN')}
                            getOptionLabel={(option: any) => `${option?.examination_name}` || ""}
                            onChange={(e: any, value: any) => {
                                setForm({ ...form, id_examination_calendar: value?.id_examination_calendar, examination_calendar: value })
                            }}
                            value={form?.examination_calendar || null}
                        />
                    </Grid>

                    <Grid
                        item
                        xs={12}
                        md={12}
                        lg={3}
                        sx={{
                            alignSelf: "end",
                        }}
                    >
                        <InputDatePicker heading='วันที่เริ่มต้นกิจกรรม' value={form?.examination_calendar?.examination_start_date || ''}
                            onChange={(e: any) => {
                                setForm({ ...form, examination_start_date: moment(e).format('YYYY-MM-DD') })
                            }} disabled />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        md={12}
                        lg={3}
                        sx={{
                            alignSelf: "end",
                        }}
                    >
                        <InputDatePicker heading='วันที่สิ้นสุดกิจกรรม' value={form?.examination_calendar?.examination_end_date || ''}
                            onChange={(e: any) => {
                                setForm({ ...form, examination_end_date: moment(e).format('YYYY-MM-DD') })
                            }} disabled />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        md={12}
                        lg={3}
                        sx={{
                            alignSelf: "end",
                        }}
                    > <InputTextField
                            heading={t('เวลาเริ่มต้นกิจกรรม')}
                            placeholder={t('เวลาเริ่มต้นกิจกรรม')}
                            required
                            value={timeToView(form?.examination_calendar?.examination_start_date) || ''}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            }}
                            helperText={
                                ""
                            }
                            disabled
                            type='time'
                        />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        md={12}
                        lg={3}
                        sx={{
                            alignSelf: "end",
                        }}
                    > <InputTextField
                            heading={t('เวลาสิ้นสุดกิจกรรม')}
                            placeholder={t('เวลาสิ้นสุดกิจกรรม')}
                            required
                            value={timeToView(form?.examination_calendar?.examination_end_date) || ''}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            }}
                            helperText={
                                ""
                            }
                            disabled
                            type='time'
                        />
                    </Grid>

                    <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        sx={{
                            alignSelf: "end",
                        }}
                    >
                        <InputDatePicker heading='วันที่ต้องการจอง' placeholder='ระบุ' value={form?.examination_calendar_date || ''}
                            onChange={(e: any) => {
                                setForm({ ...form, examination_calendar_date: moment(e).format('YYYY-MM-DD') })
                            }} />


                    </Grid>
                </Grid>



            </section>


            <section className="col-span-12 flex items-center justify-center gap-4 my-4">
                <ButtonOutlined
                    onClick={() => {
                        // navigate(routeName.cms.MeetingCalendar);
                        navigate(routeName.students.ScheduleCalenda);
                    }}
                    buttonName="ย้อนกลับ"
                    btnProps={{
                        width: "150px",
                    }}
                />


                {mode !== 'VIEW' && <ButtonPrimary
                    onClick={() => {
                        // handleSubmit(inputValueFormStudent.information);
                        handleSubmit()
                    }}
                    mode="success"
                    buttonName="ยืนยัน"
                    disabled={!form?.id_examination_calendar}
                    btnProps={{
                        width: "150px",
                    }}
                />}
            </section>
        </div >
    )
}
